import {
  LayoutDashboard, Users, Shield, Building2, Package, Factory, Warehouse,
  ClipboardCheck, ShoppingCart, CalendarClock, Landmark, Wrench, UserCog,
  FileText, BarChart3, Database, DollarSign, ArrowLeftRight, Sparkles, Plug,
  Settings, ShieldAlert, HardHat, ShieldCheck, Target, ClipboardList, Brain,
  GitBranchPlus, Building, BellRing, FileSpreadsheet, ListTodo, Receipt,
  Banknote, User, CalendarOff, Scissors, Truck, TrendingUp, TrendingDown,
  Smartphone, StickyNote, CalendarDays, GraduationCap, Recycle, Activity,
  BookOpen, UsersRound, Megaphone, MessageSquare, Rocket, Store, Calculator,
  PenLine, QrCode, Coffee, Tag, Percent, Filter, MapPin, Gavel, Camera,
  FlaskConical, Radar, Boxes, Layers, Lock, Bug, Navigation, FileImage,
  IndianRupee, Flame,
} from "lucide-react";

// ─── Odoo-style module registry: each module = one tile on the Apps screen ───
// When inside a module, its sections render as dropdown menus in the top bar.
export const MODULES = [
  {
    key: "dashboard", label: "Dashboard", icon: LayoutDashboard, color: "#2563eb", home: "/dashboard",
    sections: [
      { label: "Dashboard", items: [
        { label: "Dashboard", path: "/dashboard", icon: LayoutDashboard, module: "dashboard" },
        { label: "My Portal", path: "/my-portal", icon: User, module: "dashboard" },
      ]},
    ],
  },
  {
    key: "sales", label: "Sales & CRM", icon: ShoppingCart, color: "#7c3aed", home: "/sales",
    sections: [
      { label: "CRM", items: [
        { label: "CRM Leads", path: "/crm", icon: Target, module: "sales" },
        { label: "Sales Dashboard", path: "/crm-dashboard", icon: BarChart3, module: "sales" },
        { label: "Sales Funnel", path: "/crm/funnel", icon: Filter, module: "sales" },
        { label: "Sales Forecast", path: "/crm/forecast", icon: TrendingUp, module: "sales" },
        { label: "Sales Alerts", path: "/crm/alerts", icon: BellRing, module: "sales" },
        { label: "Customer Health", path: "/crm/customer-health", icon: Activity, module: "sales" },
      ]},
      { label: "Orders", items: [
        { label: "Sales Orders", path: "/sales", icon: ShoppingCart, module: "sales" },
        { label: "Quotations", path: "/quotations", icon: FileText, module: "sales" },
        { label: "Order Pipeline", path: "/workflow", icon: TrendingUp, module: "sales" },
        { label: "Tenders", path: "/tenders", icon: Gavel, module: "sales" },
        { label: "Surplus Sales", path: "/sales/surplus-offers", icon: Recycle, module: "sales" },
        { label: "TDC", path: "/tdc", icon: FileText, module: "sales" },
      ]},
      { label: "Pricing", items: [
        { label: "Pricelists", path: "/pricelists", icon: Tag, module: "sales" },
        { label: "Pricing Analytics", path: "/pricing-analytics", icon: BarChart3, module: "sales" },
        { label: "Cost Calculator", path: "/cost-calculator", icon: Calculator, module: "sales" },
        { label: "Discount Rules", path: "/discount-rules", icon: Percent, module: "sales" },
      ]},
      { label: "Team", items: [
        { label: "Sales Teams", path: "/sales-teams", icon: MapPin, module: "sales" },
        { label: "Field Tracker", path: "/field-tracker", icon: Navigation, module: "field_tracker" },
      ]},
    ],
  },
  {
    key: "purchase", label: "Purchase", icon: Package, color: "#0891b2", home: "/purchase",
    sections: [
      { label: "Procurement", items: [
        { label: "Purchase Orders", path: "/purchase", icon: Package, module: "purchase" },
        { label: "Auctions", path: "/purchase/auctions", icon: Gavel, module: "purchase" },
        { label: "Vendors", path: "/vendors", icon: Store, module: "purchase" },
      ]},
    ],
  },
  {
    key: "production", label: "Manufacturing", icon: Factory, color: "#ea580c", home: "/production",
    sections: [
      { label: "Operations", items: [
        { label: "Production", path: "/production", icon: Factory, module: "production" },
        { label: "Shop Floor", path: "/shop-floor", icon: HardHat, module: "production" },
        { label: "Floor Dashboard", path: "/shop-floor/dashboard", icon: BarChart3, module: "production" },
        { label: "Floor Sheets", path: "/shop-floor/sheets", icon: ClipboardList, module: "production" },
      ]},
      { label: "Planning", items: [
        { label: "Planning", path: "/planning", icon: CalendarClock, module: "planning" },
        { label: "Targets", path: "/production/targets", icon: Target, module: "production" },
      ]},
      { label: "Analytics", items: [
        { label: "OEE Dashboard", path: "/oee", icon: Activity, module: "oee" },
        { label: "Alert Analytics", path: "/production/alerts", icon: BellRing, module: "production" },
        { label: "Mfg Analytics", path: "/production/analytics", icon: BarChart3, module: "production" },
      ]},
      { label: "Reference", items: [
        { label: "Work Instructions", path: "/work-instructions", icon: BookOpen, module: "work_instructions" },
      ]},
    ],
  },
  {
    key: "inventory", label: "Inventory", icon: Warehouse, color: "#16a34a", home: "/inventory",
    sections: [
      { label: "Stock", items: [
        { label: "Stock", path: "/inventory", icon: Warehouse, module: "inventory" },
        { label: "Forecast", path: "/inventory/forecast", icon: TrendingUp, module: "inventory" },
        { label: "Transfers", path: "/transfers", icon: GitBranchPlus, module: "inventory" },
        { label: "Departments", path: "/departments", icon: Building, module: "inventory" },
        { label: "Plate Cutting", path: "/plate-cutting", icon: Scissors, module: "inventory" },
        { label: "Pipe/Bar Cutting", path: "/bar-cutting", icon: Scissors, module: "inventory" },
      ]},
      { label: "Dispatch", items: [
        { label: "Packing Lists", path: "/packing-lists", icon: ClipboardList, module: "inventory" },
        { label: "Dispatch Notes", path: "/dispatch-notes", icon: Truck, module: "inventory" },
        { label: "AI Dispatch Plan", path: "/dispatch/ai-planning", icon: Brain, module: "inventory" },
      ]},
    ],
  },
  {
    key: "quality", label: "Quality", icon: ClipboardCheck, color: "#0d9488", home: "/quality",
    sections: [
      { label: "Quality", items: [
        { label: "Inspections", path: "/quality", icon: ClipboardCheck, module: "quality_control" },
        { label: "Test Certificates", path: "/quality/test-certificates", icon: FileText, module: "quality_control" },
        { label: "Heat Traceability", path: "/quality/heat-trace", icon: Flame, module: "quality_control" },
        { label: "AI Pipe Inspection", path: "/quality/pipe-inspection", icon: Camera, module: "quality_control" },
        { label: "AI MTC Verification", path: "/quality/mtc-verification", icon: FlaskConical, module: "quality_control" },
      ]},
    ],
  },
  {
    key: "finance", label: "Finance", icon: Landmark, color: "#4f46e5", home: "/finance",
    sections: [
      { label: "Billing", items: [
        { label: "Invoices", path: "/finance", icon: Landmark, module: "finance" },
        { label: "Expenses", path: "/expenses", icon: Receipt, module: "finance" },
        { label: "Advance Pay", path: "/advance-payments", icon: Banknote, module: "finance" },
        { label: "Commission", path: "/commission", icon: DollarSign, module: "finance" },
      ]},
      { label: "Banking", items: [
        { label: "Banking", path: "/banking", icon: Building2, module: "finance" },
        { label: "Credit Control", path: "/credit-control", icon: ShieldCheck, module: "finance" },
        { label: "LC Register", path: "/lc-register", icon: FileSpreadsheet, module: "finance" },
      ]},
      { label: "Accounting", items: [
        { label: "Accounting", path: "/accounting", icon: Calculator, module: "finance" },
        { label: "Job Work", path: "/job-work", icon: ArrowLeftRight, module: "job_work" },
      ]},
    ],
  },
  {
    key: "hr", label: "HR & People", icon: UserCog, color: "#db2777", home: "/hr",
    sections: [
      { label: "People", items: [
        { label: "HR & Payroll", path: "/hr", icon: UserCog, module: "hr" },
        { label: "Leave Mgmt", path: "/leaves", icon: CalendarOff, module: "hr" },
        { label: "Employee Loans", path: "/employee-loans", icon: Banknote, module: "hr" },
        { label: "Training", path: "/hr/training", icon: GraduationCap, module: "hr" },
      ]},
      { label: "Extended", items: [
        { label: "Contractors", path: "/contractors", icon: HardHat, module: "contractors" },
        { label: "Workforce Intel", path: "/workforce-intelligence", icon: UsersRound, module: "workforce_intel" },
        { label: "E-Sign", path: "/esign", icon: PenLine, module: "esign" },
      ]},
    ],
  },
  {
    key: "projects", label: "Projects", icon: Rocket, color: "#9333ea", home: "/projects",
    sections: [
      { label: "Projects", items: [
        { label: "Projects", path: "/projects", icon: Rocket, module: "dashboard" },
        { label: "Contracts", path: "/contracts-tracker", icon: FileSpreadsheet, module: "dashboard" },
        { label: "Tasks", path: "/tasks", icon: ListTodo, module: "dashboard" },
        { label: "Meetings", path: "/meetings", icon: CalendarDays, module: "dashboard" },
      ]},
    ],
  },
  {
    key: "approvals", label: "Approvals", icon: ShieldCheck, color: "#ca8a04", home: "/approvals",
    sections: [
      { label: "Approvals", items: [
        { label: "Approvals", path: "/approvals", icon: ShieldCheck, module: "approvals" },
      ]},
    ],
  },
  {
    key: "maintenance", label: "Maintenance", icon: Wrench, color: "#57534e", home: "/maintenance",
    sections: [
      { label: "Maintenance", items: [
        { label: "Maintenance", path: "/maintenance", icon: Wrench, module: "maintenance" },
        { label: "Assets", path: "/assets", icon: QrCode, module: "assets" },
      ]},
    ],
  },
  {
    key: "security", label: "Security", icon: Lock, color: "#dc2626", home: "/security",
    sections: [
      { label: "Security", items: [
        { label: "Access Control", path: "/security", icon: Lock, module: "security" },
        { label: "AI Cameras", path: "/ai-cameras", icon: Camera, module: "security" },
        { label: "Gate ANPR Live", path: "/gate-anpr", icon: Radar, module: "security" },
        { label: "Security Intel", path: "/security/intelligence", icon: ShieldAlert, module: "security" },
        { label: "Audit Trail", path: "/audit-trail", icon: Activity, module: "audit_trail" },
        { label: "Visitors", path: "/visitors", icon: UsersRound, module: "visitors" },
      ]},
    ],
  },
  {
    key: "reports", label: "Reports", icon: BarChart3, color: "#0369a1", home: "/reports",
    sections: [
      { label: "Reports", items: [
        { label: "Reports", path: "/reports", icon: BarChart3, module: "reports" },
        { label: "Daily Reports", path: "/manual-reports", icon: ClipboardList, module: "manual_reporting" },
        { label: "CEO Report", path: "/reports/ceo", icon: FileText, module: "reports" },
      ]},
      { label: "Analysis", items: [
        { label: "Monthly Stock", path: "/reports/stock-monthly", icon: Package, module: "reports" },
        { label: "Inventory Valuation", path: "/reports/inventory-valuation", icon: IndianRupee, module: "reports" },
        { label: "Profitability Cockpit", path: "/reports/profitability", icon: TrendingUp, module: "reports" },
        { label: "Loss Sales", path: "/reports/loss-sales", icon: TrendingDown, module: "reports" },
      ]},
      { label: "Odoo Reports", items: [
        { label: "Stock", path: "/odoo-reports/stock", icon: Package, module: "dashboard" },
        { label: "Sales Orders", path: "/odoo-reports/sales-orders", icon: ShoppingCart, module: "dashboard" },
        { label: "Dispatch", path: "/odoo-reports/dispatch", icon: Truck, module: "dashboard" },
        { label: "Planning", path: "/odoo-reports/planning", icon: CalendarClock, module: "dashboard" },
      ]},
    ],
  },
  {
    key: "marketing", label: "Marketing", icon: Target, color: "#e11d48", home: "/marketing",
    sections: [
      { label: "Marketing", items: [
        { label: "Marketing", path: "/marketing", icon: Target, module: "marketing" },
        { label: "Marketing Hub", path: "/marketing-hub", icon: Rocket, module: "marketing" },
      ]},
    ],
  },
  {
    key: "communication", label: "Communication", icon: Megaphone, color: "#f59e0b", home: "/announcements",
    sections: [
      { label: "Communication", items: [
        { label: "Announcements", path: "/announcements", icon: Megaphone, module: "announcements" },
        { label: "Daily Summary", path: "/daily-summary", icon: MessageSquare, module: "announcements" },
        { label: "Discuss", path: "/discuss", icon: Coffee, module: "dashboard" },
        { label: "Alert Center", path: "/alert-center", icon: BellRing, module: "dashboard" },
        { label: "Helpdesk", path: "/helpdesk", icon: MessageSquare, module: "dashboard" },
      ]},
    ],
  },
  {
    key: "ai", label: "AI Hub", icon: Sparkles, color: "#8b5cf6", home: "/ai",
    sections: [
      { label: "AI", items: [
        { label: "AI Assistant", path: "/ai", icon: Sparkles, module: "ai_assistant" },
        { label: "AI Command Center", path: "/ai/command-center", icon: Brain, module: "dashboard" },
        { label: "AI Anomaly Center", path: "/ai/anomaly-center", icon: Radar, module: "dashboard" },
        { label: "AI Documents", path: "/ai-documents", icon: Sparkles, module: "ai_documents" },
      ]},
    ],
  },
  {
    key: "tools", label: "Tools", icon: Boxes, color: "#64748b", home: "/documents",
    sections: [
      { label: "Workspace", items: [
        { label: "Documents", path: "/documents", icon: FileText, module: "documents" },
        { label: "Spreadsheets", path: "/spreadsheets", icon: FileSpreadsheet, module: "spreadsheets" },
        { label: "Media Library", path: "/media-library", icon: FileImage, module: "dashboard" },
        { label: "Notes", path: "/notes", icon: StickyNote, module: "dashboard" },
      ]},
      { label: "Misc", items: [
        { label: "Cafe", path: "/cafe", icon: Coffee, module: "dashboard" },
        { label: "Bug Tracker", path: "/bug-tracker", icon: Bug, module: "dashboard" },
        { label: "Mobile App", path: "/mobile-app", icon: Smartphone, module: "dashboard" },
      ]},
      { label: "Help", items: [
        { label: "Help Center", path: "/help", icon: BookOpen, module: "dashboard" },
        { label: "Implementation", path: "/implementation", icon: Rocket, module: "dashboard" },
      ]},
    ],
  },
  {
    key: "settings", label: "Settings", icon: Settings, color: "#475569", home: "/settings",
    sections: [
      { label: "Configuration", items: [
        { label: "Settings", path: "/settings", icon: Settings, module: "dashboard" },
        { label: "Company", path: "/company", icon: Building2, module: "company_profile" },
        { label: "Master Data", path: "/masters", icon: Database, module: "dashboard" },
        { label: "Users", path: "/users", icon: Users, module: "users" },
        { label: "Roles & Access", path: "/roles", icon: Shield, module: "roles" },
      ]},
      { label: "Advanced", items: [
        { label: "Module Builder", path: "/settings/module-builder", icon: Boxes, module: "dashboard" },
        { label: "Role Layouts", path: "/settings/role-layouts", icon: Layers, module: "dashboard" },
        { label: "Note Templates", path: "/settings/templates", icon: FileText, module: "dashboard" },
        { label: "Data Protection", path: "/settings/data-protection", icon: Shield, module: "dashboard" },
        { label: "Notifications", path: "/settings/notifications", icon: BellRing, module: "dashboard" },
        { label: "Integrations", path: "/integrations", icon: Plug, module: "dashboard" },
        { label: "Odoo Import", path: "/integrations/odoo-import", icon: FileSpreadsheet, module: "dashboard" },
      ]},
      { label: "Admin", items: [
        { label: "SteelOne Console", path: "/group-console", icon: Building2, module: "reports", adminOnly: true },
      ]},
    ],
  },
];

const MODULE_KEY_MAP = {
  dashboard: "dashboard", users: "dashboard", roles: "dashboard",
  company_profile: "dashboard", purchase: "purchase", production: "production",
  inventory: "inventory", quality_control: "quality", approvals: "approvals",
  sales: "sales", planning: "planning", finance: "finance", job_work: "job_work",
  maintenance: "maintenance", hr: "hr", security: "security", documents: "documents",
  reports: "reports", oee: "oee", work_instructions: "work_instructions",
  workforce_intel: "workforce_intel", announcements: "announcements",
  audit_trail: "audit_trail", contractors: "contractors", ai_assistant: "ai_assistant",
  esign: "esign", spreadsheets: "spreadsheets", ai_documents: "ai_documents",
  visitors: "security", assets: "dashboard",
};

const PATH_SUB_MODULE_MAP = {
  "/sales": "sales.sales_orders", "/crm": "sales.crm", "/crm-dashboard": "sales.crm",
  "/crm/funnel": "sales.crm", "/crm/forecast": "sales.crm", "/crm/alerts": "sales.crm",
  "/crm/customer-health": "sales.crm", "/sales-teams": "sales.sales_teams",
  "/field-tracker": "field_tracker", "/manual-reports": "manual_reporting",
  "/quotations": "sales.quotations", "/pricelists": "sales.pricelists",
  "/pricing-analytics": "sales.pricelists", "/dispatch-notes": "sales.dispatch",
  "/dispatch/ai-planning": "sales.dispatch",
  "/purchase": "purchase.purchase_orders", "/purchase/auctions": "purchase.rfq",
  "/vendors": "purchase.vendors",
  "/production": "production.entries", "/shop-floor": "production.shop_floor",
  "/shop-floor/dashboard": "production.shop_floor", "/shop-floor/sheets": "production.shop_floor",
  "/planning": "production.planning", "/production/targets": "production.targets",
  "/oee": "production.oee", "/work-instructions": "production.work_instructions",
  "/inventory": "inventory.stock", "/packing-lists": "inventory.packing",
  "/transfers": "inventory.transfers",
  "/quality": "quality.inspections", "/quality/test-certificates": "quality.test_certs",
  "/quality/pipe-inspection": "quality.pipe_inspection",
  "/finance": "finance.invoices", "/expenses": "finance.expenses",
  "/advance-payments": "finance.payments", "/commission": "finance.commission",
  "/job-work": "finance.job_work", "/banking": "finance.banking",
  "/hr": "hr.employees", "/leaves": "hr.leaves", "/employee-loans": "hr.loans",
  "/contractors": "hr.contractors", "/esign": "hr.esign",
  "/workforce-intelligence": "hr.employees", "/hr/training": "hr.training",
  "/security": "security.access_control", "/visitors": "security.visitors",
  "/audit-trail": "security.audit",
};

export function isItemVisible(item, enabledModules, hasPermission, user) {
  if (item.adminOnly && !(user?.is_superadmin || user?.role_name === "Admin")) return false;
  if (enabledModules) {
    const moduleKey = MODULE_KEY_MAP[item.module] || item.module;
    if (item.path && item.path.startsWith("/shop-floor")) {
      if (!enabledModules.includes("shop_floor") && !enabledModules.includes("production") && !enabledModules.includes("production.shop_floor")) return false;
    } else if (!enabledModules.includes(moduleKey)) {
      return false;
    }
    if (item.path) {
      const subKey = PATH_SUB_MODULE_MAP[item.path];
      if (subKey && !enabledModules.includes(subKey)) return false;
    }
  }
  if (hasPermission && item.module && item.module !== "dashboard") {
    if (!hasPermission(item.module, "view")) return false;
  }
  return true;
}

export const ALL_ITEMS = MODULES.flatMap(m => m.sections.flatMap(s => s.items));

// Returns [{...module, visibleSections}] filtered by permissions + enabled modules
export function getVisibleModules(enabledModules, hasPermission, user) {
  return MODULES.map(m => {
    const visibleSections = m.sections
      .map(s => ({ ...s, items: s.items.filter(it => isItemVisible(it, enabledModules, hasPermission, user)) }))
      .filter(s => s.items.length > 0);
    return { ...m, visibleSections };
  }).filter(m => m.visibleSections.length > 0);
}

export function getModuleHome(mod) {
  const items = mod.visibleSections ? mod.visibleSections.flatMap(s => s.items) : mod.sections.flatMap(s => s.items);
  if (items.some(it => it.path === mod.home)) return mod.home;
  return items[0]?.path || mod.home;
}

// Longest-prefix match of pathname → module
export function resolveModuleForPath(pathname) {
  if (!pathname || pathname === "/") return null;
  if (pathname.startsWith("/cm/")) return "__custom__";
  let best = null, bestLen = -1;
  for (const mod of MODULES) {
    for (const s of mod.sections) {
      for (const it of s.items) {
        if (pathname === it.path || pathname.startsWith(it.path + "/")) {
          if (it.path.length > bestLen) { best = mod; bestLen = it.path.length; }
        }
      }
    }
  }
  return best;
}

export function isPathActive(pathname, path) {
  if (!path) return false;
  if (pathname === path) return true;
  return path !== "/" && pathname.startsWith(path + "/");
}

// Records the visited page (matched to a known nav item) in localStorage
export function trackRecentPage(pathname) {
  if (!pathname || pathname === "/") return;
  let best = null, bestLen = -1;
  for (const it of ALL_ITEMS) {
    if (pathname === it.path || pathname.startsWith(it.path + "/")) {
      if (it.path.length > bestLen) { best = it; bestLen = it.path.length; }
    }
  }
  if (!best) return;
  try {
    const cur = JSON.parse(localStorage.getItem("stancor_recent_nav")) || [];
    const next = [best.path, ...cur.filter(p => p !== best.path)].slice(0, 8);
    localStorage.setItem("stancor_recent_nav", JSON.stringify(next));
  } catch { /* ignore */ }
}
